import React from "react";

export default function Footer({ t }) {
  return (
    <footer className="bg-dark text-light mt-5 pt-5">
      <div className="container py-5">
        <div className="row gy-4">
          {/* العمود الأول */}
          <div className="col-md-4">
            <h5 className="fw-bold mb-3">{t("companyName")}</h5>
            <p className="text-secondary">{t("companyDesc")}</p>
            <div className="d-flex gap-3">
              <a href="#" className="text-light fs-4">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-light fs-4">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-light fs-4">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" className="text-light fs-4">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="text-light fs-4">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* العمود الثاني */}
          <div className="col-md-4">
            <h6 className="fw-bold mb-3">{t("quickLinks")}</h6>
            <ul className="list-unstyled text-secondary">
              <li className="mb-2">
                <a className="text-decoration-none text-light" href="/services">
                  {t("services")}
                </a>
              </li>
              <li className="mb-2">
                <a className="text-decoration-none text-light" href="/about">
                  {t("about")}
                </a>
              </li>
              <li>
                <a className="text-decoration-none text-light" href="/contact">
                  {t("contact")}
                </a>
              </li>
            </ul>
          </div>

          {/* العمود الثالث */}
          <div className="col-md-4">
            <h6 className="fw-bold mb-3">{t("getInTouch")}</h6>
            <p className="text-secondary mb-1">
              <i className="fas fa-map-marker-alt me-2"></i> {t("contact.address")}
            </p>
            <p className="text-secondary mb-1">
              <i className="fas fa-phone me-2"></i> {t("contact.mobile")}
            </p>
            <p className="text-secondary">
              <i className="fas fa-envelope me-2"></i> {t("contact.mail")}
            </p>
          </div>
        </div>
      </div>

      <div className="text-center py-3 border-top border-secondary">
        <small className="text-secondary">
          © {new Date().getFullYear()} {t("companyName")} - {t("rights")}
        </small>
      </div>
    </footer>
  );
}
